import { ViewRoom } from '../../models'
import { DEFAULT_ROOM_SETTINGS } from './Settings'

export const DEFAULT_ROOM: Omit<ViewRoom, 'id'> = {
  name: 'Neuer Raum',
  settings: DEFAULT_ROOM_SETTINGS,
  tables: [],
  order: -1,
}

export const DEFAULT_ANY_ROOM: ViewRoom = {
  id: 'any',
  name: 'Beliebiger Raum',
  order: -1,
  settings: DEFAULT_ROOM_SETTINGS,
  tables: [],
}

export const OPTION_ALL_ROOMS: ViewRoom = {
  id: 'all',
  name: 'Alle Räume',
  order: -1,
  settings: DEFAULT_ROOM_SETTINGS,
  tables: [],
}
